import React, { useContext } from "react";
import {
	Route as RouterRoute,
	Redirect,
	useLocation,
	matchPath,
} from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { isBillingRestricted } from "../utils/billing";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
	const { isAuth, loading, loadingScreen, user, billing, billingLoading } = useContext(AuthContext);
	const location = useLocation();
	const isRouteMatch = rest.path
		? Boolean(
			matchPath(location.pathname, {
				path: rest.path,
				exact: rest.exact,
				strict: rest.strict,
				sensitive: rest.sensitive,
			})
		)
		: true;

	if (!isRouteMatch) {
		return null;
	}

	const companyRestricted = isAuth && isBillingRestricted(user, billing);

	const allowedWhenInactive = ["/financeiro"];
	const currentPaths = Array.isArray(rest.path)
		? rest.path
		: rest.path
			? [rest.path]
			: [];
	const isAllowedRouteWhenInactive =
		currentPaths.length === 0
			? false
			: currentPaths.some((path) => allowedWhenInactive.includes(path));

	if (loading) {
		return loadingScreen === "splash" ? null : <BackdropLoading />;
	}

	if (isAuth && billingLoading) {
		return <BackdropLoading />;
	}

	if (!isAuth && isPrivate) {
		return (
			<>
				<Redirect to={{ pathname: "/login", state: { from: location } }} />
			</>
		);
	}

	if (isAuth && !isPrivate) {
		const targetPath = companyRestricted ? "/financeiro" : "/";
		return (
			<>
				<Redirect to={{ pathname: targetPath, state: { from: location } }} />
			</>
		);
	}

	if (companyRestricted && isPrivate && !isAllowedRouteWhenInactive) {
		return (
			<>
				<Redirect to={{ pathname: "/financeiro", state: { from: location } }} />
			</>
		);
	}

	return (
		<>
			<RouterRoute {...rest} component={Component} />
		</>
	);
};

export default Route;
